export default __webpack_public_path__ + "static/media/vision-menu-grey.19369532.svg";